import styled from 'styled-components'
import { useState, useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close';

const LinkList = styled.ul`
  position: fixed;
  top: 60px;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: #68504c;
  height: auto;
  overflow: hidden;
  transition: all 0.2s;
  z-index: ${(props) => props.theme.zIndex.fixed};
`;

const Link = styled.a`
  display: inline-block;
  line-height: 1em;
  transition: all 0.3s;
  width: auto;
  padding: 9px 3px;
  color: #f2f0ed;
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  text-align: center;
  font-size: 12px;
  flex-grow: 1;

  :hover {
    background-color: #361611;
    text-decoration: none;
    color: white;
  }

  :focus {
    background-color: #361611;
    text-decoration: none;
    color: white;
  }
`;

const Filter = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #68504c;
  background-color: #f2f0ed;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 6px;
  margin: 0px 6px;  
  align-self: flex-start;
`;

const Close = styled(CloseIcon)`
  margin-right: 4px;
  max-width: 14px;
  max-height: 14px;
`

export default ({
  handleItemsForSaleAccordion,
  handleEquipmentAccordion,
  showFilter,
}) => {

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    window.addEventListener("hide_filter", () => {
      setIsOpen(false);
    })
  }, [])

  return (
    <LinkList>
      <Link id="header_auctions" href="/">
        Auctions
      </Link>
      <Link id="header_items_for_sale" onClick={handleItemsForSaleAccordion}>
        Items for Sale
      </Link>
      <Link
        id="header_equipment"
        onClick={() => {
          handleEquipmentAccordion();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        Equipment
      </Link>
      <Link id="header_results" href="/auction/results">
        Results
      </Link>
      <Link id="header_appraisals" href="/appraisals">
        Appraisals
      </Link>
      {showFilter && (
        <Filter
          onClick={() => {
            document.body.classList.toggle('showFilter')
            setIsOpen(!isOpen)
          }}
        >
          {isOpen ? (
            <Close />
          ) : (
            <i
              style={{ fontSize: '14px', marginRight: '4px' }}
              className='bi bi-filter'
            />
          )}
          Filter
        </Filter>
      )}
    </LinkList>
  );
};
